import {personSvg as Icon__small__personSvg} from '../Icon__small/Icon__small--person.js'

export var person = {
  name: 'person',
  category: 'icon',
  colorable: true,
  svg: Icon__small__personSvg,
};
